import React from "react";
import { Routes as Switch, Route, Navigate } from "react-router-dom";
import { WebCheckIn } from "../pages/WebCheckinUser/CheckIns";
import { WebCheckOut } from "../pages/WebCheckinUser/CheckOut";
import { GuestLinkResolver } from "../pages/WebCheckinUser/GuestLink";

export const WebCheckinUserRoutes: React.FC = () => {
  return (
    <div style={{ display: "flex", flex: 1 }}>
      <Switch>
        <Route path="/g/:code" element={<GuestLinkResolver />} />
        <Route path="/checkin" element={<WebCheckIn />} />
        <Route path="/checkout" element={<WebCheckOut />} />
      </Switch>
    </div>
  );
};
